import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { mutationAppLogOut } from 'gql/mutations/app';
import { trackEvent, reportError } from 'lib/tracking';

import Logout from './Logout';

const LogoutContainer = () => {
  const { t } = useTranslation();
  useEffect(() => {
    (async function asyncEffect() {
      try {
        await mutationAppLogOut();
        trackEvent('auth', 'logout');
      } catch (err) {
        reportError('auth', 'logout', err);
      }
    })();
  }, []);
  return <Logout t={t} />;
};

export default LogoutContainer;
